
enum SectionList {
  CallLeftPanel = "CallLeftPanel",
  CallRightPanel = "CallRightPanel",
  CallTopPanel = "CallTopPanel",
  CallBottomPanel = "CallBottomPanel",
  CallButtonsList = "CallButtonsList",
  CallModal = "CallModal",
  CallTopBar = "CallTopBar",
  AbsoluteTop = "AbsoluteTop",
  AbsoulteBottom = "AbsoulteBottom",
  LocalButtons = "LocalButtons",
}


export { SectionList };
